export default __webpack_public_path__ + "media/images/backgrounds/bg-13-1920x760-951e0b3a0ab311fb9ccebbebedd4cfa6.jpg";